import React from "react";

const ManualEventMarker = () => {
  return (
    <div>
      <span style={{ color: "#64748a" }} className="fa-stack fa-2x">
        <i className="fas fa-map-marker fa-stack-2x"></i>
        <span style={{ color: "#edbd7f" }}>
          <i className="fas fa-map-pin fa-stack-1x"></i>
        </span>
      </span>
      `
    </div>
  );
};

export default ManualEventMarker;
